import React from 'react';
import { PaymentInfo } from 'baseTypes';
import PaymentMethod from './PaymentMethod';
import Header from './Header';
import TotalBill from './TotalBill';
import Footer from './Footer';

import { Wrapper, PaymentSectionLayout } from './index.view';
import SplitBillProvider from 'components/Layout/SplitBill/index.context';

interface LayoutProps {
  paymentInfo: PaymentInfo;
  children: React.ReactNode;
  isEmptyPage?: boolean;
  showFooter?: boolean;
}

const Layout = ({ children, paymentInfo, isEmptyPage, showFooter = true }: LayoutProps) => {
  return (
    <Wrapper id="wrapper-scroll-hook">
      <Header />
      <PaymentSectionLayout hasFooter={!isEmptyPage && showFooter}>
        <SplitBillProvider>
          {isEmptyPage ? (
            <div>{children}</div>
          ) : (
            <>
              <TotalBill paymentInfo={paymentInfo} />
              <PaymentMethod>
                {children}
              </PaymentMethod>
            </>
          )}
        </SplitBillProvider>
      </PaymentSectionLayout>
      {!isEmptyPage && showFooter && <Footer provider={paymentInfo?.merchantProvider} />}
    </Wrapper>
  );
};
export default Layout;
